var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isMobile && _vm.routeName != 'joinMobile')?_c('div',{class:[_vm.isMobile ? 'mobile-entry' : 'entry'],on:{"click":_vm.goJoin}},[_vm._v(" Become a partner >> ")]):_vm._e(),_c('div',{class:[_vm.isMobile ? 'mobile-service' : 'service'],on:{"click":_vm.toUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }